// apply_for_waitlist accepts a new creator application from the same email once the last one is this many days
// old; until then the web apply page keeps a returning applicant's stored application on its Thank-you step.
const CREATOR_REAPPLY_WAIT_DAYS = 90;

module.exports = {
  CREATOR_REAPPLY_WAIT_DAYS
};
